import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

type UseCreateCameraSnapshotParams = {
  camera_id: string;
  // Should be set for non-linked cameras
  gateway_id?: string;
};

export function useCreateCameraSnapshot({
  onSettled,
  onMutate,
  ...options
}: UseMutationOptions<
  { file_id: string },
  APIError,
  UseCreateCameraSnapshotParams
> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ camera_id, ...params }) => {
      const { data } = await client.post(
        `/apps/${applicationID}/cameras/${camera_id}/snapshot`,
        params
      );

      return data;
    },
    {
      ...options,
      onSettled: (...args) => {
        onSettled?.(...args);

        queryClient.invalidateQueries(['files']);
        queryClient.invalidateQueries(['file']);
        queryClient.invalidateQueries(['cameras']);
        queryClient.invalidateQueries(['camera']);
        queryClient.invalidateQueries(['video-sources']);
      },
    }
  );
}
